export default __webpack_public_path__ + "static/media/mapMarker.900b26ff.svg";